import { UserAction, } from '@thoughtspot/metrics';
import { getCurrentOrgId } from '@thoughtspot/session-service';
import { BasePageContext } from "../../../../contexts/basepage-context";
import { IDP_TYPE } from "../../../saml/constant";
export const toConnectionTrackingType = (idpType) => idpType === IDP_TYPE.SAML ? 'saml' : 'oidc';
const buildEmitter = (metricsService, adminSection) => (eventKey, props) => {
    metricsService?.collectEvent(new UserAction(eventKey), {
        adminSection,
        userRole: getCurrentOrgId() === -1 ? 'cluster_admin' : 'org_admin',
        ...props,
    });
};
const buildUserTrackers = (metricsService) => {
    const emit = buildEmitter(metricsService, 'users');
    return {
        tabViewed: (props) => emit('ADMIN_USER_TAB_VIEWED', props),
        listSearched: (props) => emit('ADMIN_USER_LIST_SEARCHED', props),
        listFiltered: (props) => emit('ADMIN_USER_LIST_FILTERED', props),
        listSorted: (props) => emit('ADMIN_USER_LIST_SORTED', props),
        listPaginated: (props) => emit('ADMIN_USER_LIST_PAGINATED', props),
        createClicked: (props) => emit('ADMIN_USER_CREATE_CLICKED', props),
        createDialogViewed: (props) => emit('ADMIN_USER_CREATE_DIALOG_VIEWED', props),
        createStepCompleted: (props) => emit('ADMIN_USER_CREATE_STEP_COMPLETED', props),
        createSubmitted: (props) => emit('ADMIN_USER_CREATE_SUBMITTED', props),
        createSucceeded: (props) => emit('ADMIN_USER_CREATE_SUCCEEDED', props),
        createFailed: (props) => emit('ADMIN_USER_CREATE_FAILED', props),
        createCancelled: (props) => emit('ADMIN_USER_CREATE_CANCELLED', props),
        detailsViewed: (props) => emit('ADMIN_USER_DETAILS_VIEWED', props),
        editClicked: (props) => emit('ADMIN_USER_EDIT_CLICKED', props),
        editSaved: (props) => emit('ADMIN_USER_EDIT_SAVED', props),
        editFailed: (props) => emit('ADMIN_USER_EDIT_FAILED', props),
        statusChanged: (props) => emit('ADMIN_USER_STATUS_CHANGED', props),
        orgAssigned: (props) => emit('ADMIN_USER_ORG_ASSIGNED', props),
        orgUnassigned: (props) => emit('ADMIN_USER_ORG_UNASSIGNED', props),
        groupAssigned: (props) => emit('ADMIN_USER_GROUP_ASSIGNED', props),
        groupUnassigned: (props) => emit('ADMIN_USER_GROUP_UNASSIGNED', props),
        deleteClicked: (props) => emit('ADMIN_USER_DELETE_CLICKED', props),
        deleteConfirmed: (props) => emit('ADMIN_USER_DELETE_CONFIRMED', props),
        deleteSucceeded: (props) => emit('ADMIN_USER_DELETE_SUCCEEDED', props),
        deleteFailed: (props) => emit('ADMIN_USER_DELETE_FAILED', props),
        deleteCancelled: (props) => emit('ADMIN_USER_DELETE_CANCELLED', props),
        bulkActionPerformed: (props) => emit('ADMIN_USER_BULK_ACTION_PERFORMED', props),
        exported: (props) => emit('ADMIN_USER_EXPORTED', props),
        userInvited: (props) => emit('USER_INVITED', props),
    };
};
const buildGroupTrackers = (metricsService) => {
    const emit = buildEmitter(metricsService, 'groups');
    return {
        groupCreated: (props) => emit('GROUP_CREATED', props),
        groupUpdated: (props) => emit('GROUP_UPDATED', props),
        groupDeleted: (props) => emit('GROUP_DELETED', props),
        importInitiated: (props) => emit('GROUP_IMPORT_INITIATED', props),
        exportInitiated: (props) => emit('GROUP_EXPORT_INITIATED', props),
        roleAssignedToUser: (props) => emit('ROLE_ASSIGNED_TO_USER', props),
    };
};
const buildRoleTrackers = (metricsService) => {
    const emit = buildEmitter(metricsService, 'roles');
    return {
        roleCreated: (props) => emit('ROLE_CREATED', props),
        roleUpdated: (props) => emit('ROLE_UPDATED', props),
        roleDeleted: (props) => emit('ROLE_DELETED', props),
        roleAssignedToUser: (props) => emit('ROLE_ASSIGNED_TO_USER', props),
    };
};
const buildAuthTrackers = (metricsService) => {
    const emit = buildEmitter(metricsService, 'authentication');
    return {
        connectionCreated: (props) => emit('AUTH_CONNECTION_CREATED', props),
        connectionUpdated: (props) => emit('AUTH_CONNECTION_UPDATED', props),
        connectionToggled: (props) => emit('AUTH_CONNECTION_TOGGLED', props),
        connectionDeleted: (props) => emit('AUTH_CONNECTION_DELETED', props),
        defaultConnectionSet: (props) => emit('AUTH_DEFAULT_CONNECTION_SET', props),
    };
};
let cachedMetricsService;
let cachedUserTrackers = null;
let cachedGroupTrackers = null;
let cachedRoleTrackers = null;
let cachedAuthTrackers = null;
const refreshCacheIfNeeded = (metricsService) => {
    if (cachedMetricsService !== metricsService) {
        cachedMetricsService = metricsService;
        cachedUserTrackers = null;
        cachedGroupTrackers = null;
        cachedRoleTrackers = null;
        cachedAuthTrackers = null;
    }
};
export const useAdminUserTracking = () => {
    const { metricsService } = BasePageContext();
    refreshCacheIfNeeded(metricsService);
    if (!cachedUserTrackers) {
        cachedUserTrackers = buildUserTrackers(metricsService);
    }
    return cachedUserTrackers;
};
export const useAdminGroupTracking = () => {
    const { metricsService } = BasePageContext();
    refreshCacheIfNeeded(metricsService);
    if (!cachedGroupTrackers) {
        cachedGroupTrackers = buildGroupTrackers(metricsService);
    }
    return cachedGroupTrackers;
};
export const useAdminRoleTracking = () => {
    const { metricsService } = BasePageContext();
    refreshCacheIfNeeded(metricsService);
    if (!cachedRoleTrackers) {
        cachedRoleTrackers = buildRoleTrackers(metricsService);
    }
    return cachedRoleTrackers;
};
export const useAdminAuthTracking = () => {
    const { metricsService } = BasePageContext();
    refreshCacheIfNeeded(metricsService);
    if (!cachedAuthTrackers) {
        cachedAuthTrackers = buildAuthTrackers(metricsService);
    }
    return cachedAuthTrackers;
};
//# sourceMappingURL=admin-tracking.js.map